import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import cn from 'classnames'

import { ReactComponent as IconSortable } from 'assets/icons/IconSortable.svg'
import { ReactComponent as IconChevron } from 'assets/icons/IconChevron.svg'
import ProductList from './ProductList'
import { sortBy } from 'lodash'
import { getAssignedItemsToCurrentModifierGroup } from 'store/Items/selector'

const ModifierGroupItem = ({
  uuid,
  modifierGroupsSortingMode,
  name,
  handleItemClick,
  assignedItems,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const assignedItemsToCurrentModifierGroup = useSelector((state) =>
    getAssignedItemsToCurrentModifierGroup(state, uuid)
  )

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: uuid, disabled: !modifierGroupsSortingMode })

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  }

  useEffect(() => {
    if (!modifierGroupsSortingMode) {
      setIsOpen(false)
    }
  }, [modifierGroupsSortingMode])

  return (
    <div className="item-wrapper">
      <div
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
        onClick={handleItemClick}
      >
        <div className={cn('item', { '-is-dragging': isDragging })}>
          <div className="row">
            <div className="item-info-wrapper -bold">
              {modifierGroupsSortingMode && (
                <IconSortable className="item-info-wrapper__icon" />
              )}
              {name}
            </div>
            <div className="item-info-wrapper">
              {assignedItemsToCurrentModifierGroup.length}
            </div>
          </div>
        </div>
        {isOpen && (
          <ProductList
            assignedItems={sortBy(assignedItems, [
              'sortOrder',
              'name',
            ])}
          />
        )}
      </div>
      {modifierGroupsSortingMode && (
        <button
          className={cn('clickable-button', { '-is-open': isOpen })}
          onClick={(e) => setIsOpen(!isOpen)}
        >
          <IconChevron />
        </button>
      )}
    </div>
  )
}

export default ModifierGroupItem
